class EventCenter {
  id = 0;
  eventCache = [];
  idToOffFun = {}; //用作移除监听器 id -> off fun
  on(name: string, fn) {
    if (this.eventCache[name]) this.eventCache[name].push(fn);
    else this.eventCache[name] = [fn];
    this.idToOffFun[this.id] = () => this.off(name, fn);
    return this.id++;
  }
  off(name: string, fn) {
    let tasks = this.eventCache[name];
    if (tasks) {
      const index = tasks.findIndex((f) => f === fn);
      if (index >= 0) {
        tasks.splice(index, 1);
      }
    }
  }
  emit(name: string, param: object) {
    if (this.eventCache[name]) {
      //创建副本，数组不会因回调函数的继续注册相同事件而死循环
      let tasks = this.eventCache[name].slice();
      tasks?.forEach((fn) => {
        fn?.(param);
      });
    }
  }
}
const eventCenter = new EventCenter();
export default {
  addListener(name: string, fn) {
    return eventCenter.on(name, fn);
  },
  removeListener(id: number) {
    if (eventCenter.idToOffFun[id]) {
      eventCenter.idToOffFun[id]();
      delete eventCenter.idToOffFun[id];
    }
  },
  emit(name: string, param: object) {
    return eventCenter.emit(name, param);
  },
};
